export default __webpack_public_path__ + "static/media/LENS_CULINARIS_TEKAY_fragment_6.6e69b9e4.jpg";